import React from 'react'

import { createHashHistory } from 'history'

import { connect } from 'react-redux'

import { coursesRequest } from '../reducers'

import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  translate,
  ViewTitle,
  DateField,
} from 'admin-on-rest'
import { Link } from 'react-router-dom'

import { Card, CardActions } from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import Paper from 'material-ui/Paper'
import RaisedButton from 'material-ui/RaisedButton'
import { StudentGradeField } from '../components'

import { dateParser } from '../helpers'

const history = createHashHistory()

class StudentCredits extends React.Component {
  componentDidMount() {
    this.props.coursesRequest()
  }

  getCreditsPerYearArray() {
    let yearlyCredits = {
      2022: { totalCourses: 0, totalCredits: 0 },
    }
    if (this.props.courses) {
      Object.keys(this.props.courses).map((courseId) => {
        const course = this.props.courses[courseId]
        // console.log('course', course)
        if (!course.hasOwnProperty('year')) {
          return
        }

        if (!yearlyCredits.hasOwnProperty(course.year)) {
          yearlyCredits[course.year] = { totalCourses: 0, totalCredits: 0 }
        }
        yearlyCredits[course.year].totalCourses++
        yearlyCredits[course.year].totalCredits += course.credits
      })
    }
    return yearlyCredits
  }

  render() {
    // console.log('credits: ', this.props)

    // if (!this.props.courses || Object.keys(this.props.courses).length === 0)
    //   return null

    let courses = this.props.courses || {}

    // console.log(this.getCreditsPerYearArray())

    let creditsPerYearArray = this.getCreditsPerYearArray()

    return (
      <div style={styles.main}>
        <Paper style={styles.paper} zDepth={1}>
          <ViewTitle title="Credite" />
          <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>An</TableHeaderColumn>
                <TableHeaderColumn>Total Cursuri</TableHeaderColumn>
                <TableHeaderColumn>Total Credite</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {Object.keys(creditsPerYearArray).map((year) => (
                <TableRow key={year}>
                  <TableRowColumn>{year}</TableRowColumn>
                  <TableRowColumn>
                    {creditsPerYearArray[year].totalCourses}
                  </TableRowColumn>
                  <TableRowColumn>
                    {creditsPerYearArray[year].totalCredits}
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <ViewTitle title="Istoric cursuri" />
          <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>Denumire curs</TableHeaderColumn>
                <TableHeaderColumn>Data curs</TableHeaderColumn>
                <TableHeaderColumn>Credite obtinute</TableHeaderColumn>
                <TableHeaderColumn>Nota obtinuta</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {Object.values(courses).map((course, index) => (
                <TableRow key={index}>
                  <TableRowColumn>
                    <Link to={`course/show/${course.id}`}>
                      {course.course.name}
                    </Link>
                  </TableRowColumn>
                  <TableRowColumn>
                    <DateField
                      label="Data curs"
                      source="date"
                      parse={dateParser}
                      record={course.course}
                    />
                  </TableRowColumn>
                  <TableRowColumn>{course.credits}</TableRowColumn>
                  <TableRowColumn>
                    <StudentGradeField record={course.course} />
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    )
  }
}

const CourseTitle = ({ record, push }) => (
  <Link to={`course/show/${record.id}`}>{record.name}</Link>
)

const styles = {
  main: {},
  paper: {},
  button: { marginTop: 50 },
}

export default connect(({ students }) => ({ courses: students.courses }), {
  coursesRequest,
})(StudentCredits)



// WEBPACK FOOTER //
// ./src/students/StudentCredits.js